import React from 'react';

export function BoletoIcon() {
  return (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 0.666748V17.3334H2.16667V2.33341H13.8333V17.3334H15.5V0.666748H0.5Z" fill="black" />
      <path d="M3.83333 7.33342H12.1667V5.66675H3.83333V7.33342Z" fill="black" />
      <path d="M5.5 15.6667H3.83333V17.3334H5.5V15.6667Z" fill="black" />
      <path d="M8.83333 15.6667H7.16667V17.3334H8.83333V15.6667Z" fill="black" />
      <path d="M10.5 15.6667H12.1667V17.3334H10.5V15.6667Z" fill="black" />
      <path d="M8.83333 10.6667H3.83333V9.00008H8.83333V10.6667Z" fill="black" />
    </svg>
  );
}
